module.exports = __webpack_public_path__ + "img/album16_04.ccb4e88b.jpg";